import React, { useState } from 'react';
import { Modal, Box, TextField, Button, Checkbox, FormControlLabel, Alert } from '@mui/material';
import moment from 'moment';
import axiosInstance from '../utills/axiosInstance';

const ODModal = ({ open, day, onClose, onSubmit }) => {
	const [reason, setReason] = useState('');
	const [allowances, setAllowances] = useState(false);
	const [foodAmount, setFoodAmount] = useState('');
	const [fuelAmount, setFuelAmount] = useState('');
	const [foodFile, setFoodFile] = useState(null);
	const [fuelFile, setFuelFile] = useState(null);
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);

	const handleSubmit = async () => {
		if (!reason.trim()) {
			setError('Reason is required');
			return;
		}

		const odDate = new Date(day);
		if (isNaN(odDate.getTime())) {
			setError('Invalid date selected');
			return;
		}
		const dateStr = moment(odDate).format('YYYY-MM-DD');

		const formData = new FormData();
		formData.append('date', dateStr);
		formData.append('reason', reason);
		formData.append('allowances', allowances.toString());
		if (allowances) {
			formData.append('foodAmount', foodAmount);
			formData.append('fuelAmount', fuelAmount);
			if (foodFile) formData.append('foodBill', foodFile);
			if (fuelFile) formData.append('fuelBill', fuelFile);
		}

		console.log('FormData contents:');
		for (let [key, value] of formData.entries()) {
			console.log(`${key}:`, value.name || value);
		}

		setLoading(true);
		setError('');
		try {
			await axiosInstance.post('/api/od/apply', formData);
			onSubmit(true);
		} catch (err) {
			setError(err.response?.data?.msg || 'Failed to apply OD');
			onSubmit(false);
		} finally {
			setLoading(false);
		}
	};

	const handleClose = () => {
		setReason('');
		setAllowances(false);
		setFoodAmount('');
		setFuelAmount('');
		setFoodFile(null);
		setFuelFile(null);
		setError('');
		onClose();
	};

	return (
		<Modal open={open} onClose={handleClose}>
			<Box sx={{ p: 4, bgcolor: 'white', m: 'auto', mt: '10%', width: 400 }}>
				<h3>Apply for On Duty - {moment(day).format('MMM DD, YYYY')}</h3>
				<TextField
					label="Reason"
					fullWidth
					multiline
					rows={3}
					value={reason}
					onChange={(e) => setReason(e.target.value)}
					sx={{ mb: 2 }}
					error={!!error}
					helperText={error}
				/>
				<FormControlLabel
					control={<Checkbox checked={allowances} onChange={(e) => setAllowances(e.target.checked)} />}
					label="Claim Allowances"
				/>
				{allowances && (
					<>
						<TextField
							label="Food Amount (₹)"
							type="number"
							fullWidth
							value={foodAmount}
							onChange={(e) => setFoodAmount(e.target.value)}
							sx={{ mb: 1 }}
						/>
						<input
							type="file"
							accept=".pdf,.jpg,.jpeg,.png"
							onChange={(e) => setFoodFile(e.target.files[0])}
							sx={{ mb: 2 }}
						/>
						<TextField
							label="Fuel Amount (₹)"
							type="number"
							fullWidth
							value={fuelAmount}
							onChange={(e) => setFuelAmount(e.target.value)}
							sx={{ mb: 1 }}
						/>
						<input
							type="file"
							accept=".pdf,.jpg,.jpeg,.png"
							onChange={(e) => setFuelFile(e.target.files[0])}
							sx={{ mb: 2 }}
						/>
					</>
				)}
				<Button onClick={handleSubmit} variant="contained" fullWidth disabled={loading} sx={{ mt: 2 }}>
					{loading ? 'Submitting...' : 'Submit OD'}
				</Button>
			</Box>
		</Modal>
	);
};

export default ODModal;
